import React from 'react'
import styled from 'styled-components'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'

import Grain from './Grain'

const HomeHero = ({ featuredImage, notFound, children }) => {
  return (
    <Wrapper className="event-hero">
      {featuredImage && (
        <GatsbyImage
          className="event-hero-background"
          imgClassName="event-hero-background-image"
          image={featuredImage.asset.gatsbyImageData}
          alt={featuredImage?.alt ? featuredImage.alt : ''}
          loading="eager"
          objectPosition={`${
            featuredImage?.hotspot ? featuredImage?.hotspot.x * 100 : 50
          }% ${featuredImage?.hotspot ? featuredImage?.hotspot.y * 100 : 50}%`}
          layout="constrained"
        />
      )}
      {notFound && (
        <StaticImage
          className="event-hero-404"
          src="../assets/images/not-found.webp"
          alt=""
        />
      )}
      <Grain />
      <Scrim />
      <Container className="container">{children}</Container>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  position: relative;
  width: 100%;
  height: auto;

  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto;

  background: var(--color-background);

  .event-hero-background {
    grid-row: 1 / 2;
    grid-column: 1 / -1;
    aspect-ratio: 4 / 3;
    width: 100%;
    height: auto;
  }

  .event-hero-404 {
    grid-row: 1 / 2;
    grid-column: 1 / -1;
    width: 100%;
    height: 100%;
    opacity: 0.1;

    img {
      object-position: 50% 0%;
    }
  }

  .grain {
    z-index: 1;
    grid-row: 1 / 2;
    grid-column: 1 / -1;
    width: 100%;
    height: 100%;
  }

  .scrim {
    z-index: 3;
    grid-row: 1 / 2;
    grid-column: 1 / -1;
    width: 100%;
    height: 100%;
  }

  @media (min-width: 1024px) and (orientation: landscape) {
    grid-template-rows: minmax(0, 1fr);
    height: calc(100vh - var(--header-height));

    .event-hero-background,
    .event-hero-404 {
      aspect-ratio: unset;
      height: 100%;
    }
  }
`

const Container = styled.div`
  z-index: 4;
  grid-row: 2 / 3;
  grid-column: 1 / -1;
  max-width: var(--max-width);
  padding: 0 var(--padding-x) var(--size-6);
  margin: 0 auto;
  text-align: center;
  transform: translateY(-50%);

  @media (min-width: 768px) {
    padding-bottom: var(--size-8);
  }

  @media (min-width: 1024px) {
    padding-bottom: var(--size-16);
  }

  @media (min-width: 1024px) and (orientation: landscape) {
    grid-row: 1 / 2;
    align-self: end;
    transform: none;
  }
`

const Scrim = styled.div`
  z-index: 1;
  grid-row: 1 / 2;
  grid-column: 1 / -1;

  // This one only spans half the height...
  background: var(--color-gradient);
`

export default HomeHero
